<p-confirmPopup></p-confirmPopup>
<!-- <p-confirmdialog /> -->

<p-table #dt1 [value]="data || []" [dataKey]="key" [tableStyle]="{ 'min-width': '60rem' }" [paginator]="paginator"
    [rowsPerPageOptions]="rows" [rows]="rows[0]" [showCurrentPageReport]="true"
    currentPageReportTemplate="{first} de {totalRecords}" [globalFilterFields]="filtrosGlobal"
    [scrollHeight]="scrollHeight" [resizableColumns]="true" [scrollable]="true" styleClass="p-datatable-sm"
    columnResizeMode="expand" selectionMode="single" [(selection)]="selectedProduct" (onRowSelect)="onRowSelect($event)"
    [showGridlines]="true" [virtualScroll]="virtualScroll" [virtualScrollItemSize]="32"
    (onFilter)="onTableFilter($event)">

    <!-- =========================================================================================================================== -->
    <!-- ********************************************************* CAPTION ********************************************************* -->
    <!-- =========================================================================================================================== -->

    <ng-template pTemplate="caption" >
        <div class="flex gap-3" *ngIf="caption">

            <!-- FILTRO GLOBAL -->

            <p-iconfield *ngIf="filterGlobal">
                <p-inputicon styleClass="pi pi-search" />
                <input type="text" pInputText (input)="onGlobalFilter($event.target['value'])"
                    (input)="manualFilter($event.target['value'])" placeholder="Buscar" pSize="small" class="h-2rem" />
            </p-iconfield>

            <!-- FIN FILTRO GLOBAL -->

            <p-button variant="outlined" severity="primary" (click)="clear(dt1)" *ngIf="filter" size="small"
                icon="pi pi-filter-slash" class="buttons_tabla_generales" styleClass="h-full w-full"
                (click)="notificarCambioFiltros()" />

            <!-- TITULO -->

            <ng-content>
                <div class="text-xs align-content-center">
                    {{title}}
                </div>
            </ng-content>

            <!-- FIN TITULO -->

            <!-- BOTONES DEFINIDOS -->

            <ng-container *ngFor="let button of customButtons">
                <p-button variant="outlined" severity="primary" (click)="button.function()" size="small"
                    [icon]="button.icon" [pTooltip]="button.toolTip" [loading]="button.loading"
                    *ngIf="button && button.type === 'button'" [disabled]="button.disabled"
                    class="buttons_tabla_generales" styleClass="h-full w-full" />
                <p-splitbutton [icon]="button.icon" size="small" (onClick)="button.function()" outlined
                    severity="primary" [model]="button.items" [pTooltip]="button.toolTip" [disabled]="button.disabled"
                    class="buttons_tabla_generales" styleClass="h-full w-full" *ngIf="button.type==='splitbutton'" />
            </ng-container>



            <!-- FIN BOTONES DEFINIDOS -->

            <!-- CONFIGURACION DE CABECERAS -->

            <p-button variant="outlined" severity="primary" (click)="showOptionColumns()" *ngIf="id" size="small"
                icon="pi pi-cog" class="buttons_tabla_generales" styleClass="h-full w-full" />

            <!-- FIN CONFIGURACION DE CABECERAS -->

            <!-- LEYENDA -->

            <!-- LEYENDA IMAGEN -->
            <div class="leyendas-container flex align-items-center ml-auto">
                <ng-container *ngFor="let leyenda of customLeyendas">
                    <div class="leyenda-item flex items-center ml-4">
                        <img [src]="leyenda.src" alt="" class="h-1rem w-1rem mr-1 inline-block">
                        <span class="text-[10px] align-middle">{{ leyenda.texto }}</span>
                    </div>
                </ng-container>
            </div>

            <!-- LEYENDA COLOR HEXAGESIMAL -->
            <div class="leyendas-container flex align-items-center ml-auto">
                <ng-container *ngFor="let leyenda of customLeyendasHex">
                    <div class="leyenda-item flex align-items-center ml-4">
                        <div class="leyenda-color-circle mr-1" [style.background]="leyenda.color"></div>
                        <span class="text-500" style="font-size: 10px;">{{ leyenda.texto }}</span>
                    </div>
                </ng-container>
            </div>

            <!-- FIN LEYENDA -->

        </div>
        @if(showFilters && cadenaFiltrosConsolidada() != '' && cadenaFiltrosConsolidada() != null){
        <div class="filter-summary-container p-mt-2">
            <div class="filter-summary-content">
                <span class="filter-title">
                    <i class="pi pi-filter"></i>
                </span>

                <span class="filter-text" [innerHTML]="cadenaFiltrosConsolidada()">
                </span>
            </div>
        </div>
        }
    </ng-template>

    <!-- =========================================================================================================================== -->
    <!-- ********************************************************** HEADER ********************************************************* -->
    <!-- =========================================================================================================================== -->

    <ng-template pTemplate="header">

        <!-- NOMBRE DE LAS COLUMNAS -->
        <tr>

            <th pResizableColumn [ngStyle]="generateStyle(item.style)" *ngFor="let item of metadatatable" pFrozenColumn
                [frozen]="item.frozen" class="m-0 py-1 text-xs font-semibold">
                <div class="flex align-items-center justify-content-center" [ngStyle]="item.styleColumn">
                    <span [innerHTML]="item.title"></span>
                </div>
            </th>
        </tr>

        <!-- FIN NOMBRE DE LAS COLUMNAS -->

        <!-- FILTRO MENU -->

        <tr *ngIf="typeFilter==='menu'" class="p-0 m-0">
            <th class="m-0 py-0 px-0">menu</th>
            <th *ngFor="let item of metadatatable" pFrozenColumn [frozen]="item.frozen" class="m-0 py-0 px-0">
                <div class="flex align-items-center items-header">
                    <div class="a-w2" [pSortableColumn]="item.field" style="display: flex;justify-content: center;">
                        <p-sortIcon [field]="item.field" class="text-xs"></p-sortIcon>
                    </div>

                    <div class="a-w2" style="display: flex;justify-content: center;">

                        <p-columnFilter class="p-column-filter-menu-button" type="{{item['type']}}"
                            field="{{item.field}}" display="menu" *ngIf="filter" appendTo="body">
                        </p-columnFilter>




                    </div>

                </div>
            </th>
        </tr>

        <!-- FIN FILTRO MENU -->

        <!-- FILTRO FILA -->

        <tr *ngIf="typeFilter==='row'">

            <th *ngFor="let item of metadatatable" class="m-0 p-1">
                <div class="flex align-items-center justify-content-center gap-2 w-full">
                    <div [pSortableColumn]="item.field" class="w-4 text-xs">
                        <p-sortIcon [field]="item.field" class="text-xs"></p-sortIcon>
                    </div>
                    <div class="w-auto">
                        <ng-container *ngIf="!item.tienefiltro && item.type == 'text'"
                            style="display: flex;justify-content: center;" class="h-1rem">
                            <p-columnFilter [field]="item.field" [showMenu]="true" [showClearButton]="false"
                                matchMode="contains" class="h-1rem">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">

                                    <input pInputText [ngModel]="value" appendTo="body"
                                        (ngModelChange)="filter($event);verdato({valor:$event,funcion:filter,lista:item.list})"
                                        pSize="small" class="w-8rem py-1 text-xs">
                                </ng-template>
                            </p-columnFilter>
                        </ng-container>



                        <ng-container *ngIf="item.tienefiltro || item.type=='textAreaEditBtn'">
                            <p-columnFilter [field]="item.field" [matchMode]="getMatchMode(item)" display="menu"
                                [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <p-multiselect *ngIf="(item.type=='text' || item.type=='textAreaEditBtn')"
                                        [ngModel]="value" (ngModelChange)="filter($event)" [options]="item.list"
                                        optionLabel="nombre" optionValue="codigo" [showClear]="true"
                                        styleClass="w-full text-xs">
                                        <ng-template let-option pTemplate="item">
                                            <div class="flex items-center gap-2">
                                                <span>{{ option.nombre }}</span>
                                            </div>
                                        </ng-template>
                                    </p-multiselect>


                                </ng-template>
                            </p-columnFilter>

                        </ng-container>


                        <ng-container *ngIf="item.type == 'dropdownEdit'">
                            <p-columnFilter [field]="item.field" matchMode="equals" [showMenu]="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">

                                    <p-select [ngModel]="value" appendTo="body" [options]="item.list"
                                        optionLabel="nombre" optionValue="codigo" size="small"
                                        (onChange)="filter($event.value);verdato({valor:$event.value,funcion:filter,lista:item.list})"
                                        [filter]="true" [showClear]="true" styleClass="p-1rem" class="w-14rem" />

                                </ng-template>
                            </p-columnFilter>


                        </ng-container>

                        <ng-container
                            *ngIf="item.type === 'checkboxEdit' || item.type ==='checkboxEditForConfirmation'">

                            <div style="display: flex;justify-content: center;">
                                <p-columnFilter type="boolean" [field]="item.field" [showClearButton]="false"
                                    size="small"></p-columnFilter>
                            </div>

                        </ng-container>

                        <ng-container *ngIf="item.type === 'dateEdit' || item.type === 'date'">

                            <p-columnFilter type="date" [field]="item.field" display="menu" [showMatchModes]="true"
                                [showOperator]="true" [showAddButton]="true" matchMode="equals" dateFormat="dd/mm/yy"
                                [matchModeOptions]="dateMatchModes">


                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <p-datepicker [ngModel]="value" (onSelect)="filter($event)" dateFormat="dd/mm/yy"
                                        [showIcon]="true" inputStyleClass="w-full">
                                    </p-datepicker>
                                </ng-template>
                            </p-columnFilter>

                        </ng-container>

                    </div>
                </div>
            </th>
        </tr>

        <!-- FIN FILTRO FILA -->

    </ng-template>

    <!-- =========================================================================================================================== -->
    <!-- ********************************************************** BODY ********************************************************* -->
    <!-- =========================================================================================================================== -->

    <ng-template pTemplate="body" let-rowdata let-expanded="expanded">
        <tr [pSelectableRow]="rowdata" (contextmenu)="onRowRightClick($event, rowdata)" #rowcontext class="cursor-auto"
            [ngStyle]="styleRowDynamic?.(rowdata)">

            <td *ngFor="let item2 of metadatatable" [ngStyle]="generateStyle(item2.style)" pFrozenColumn
                [frozen]="item2.frozen" class="m-0 py-1">
                <!-- [style]="item2.color_fila === true && item2.color_funcion ? 'background-color: ' + item2.color_funcion(rowdata) : 'background-color: transparent'" -->
                <ng-container *ngIf="item2.type !== 'array'" class="body">
                    <!--==========Solo Vista (PADRES)==============-->

                    <div class="row-button-table flex align-items-center justify-content-center h-10"
                        *ngIf="item2.type == 'icon#'">
                        <div class="leyenda-icon-container">
                            <div class="leyenda-icon-table" [style.background]="item2.function(rowdata)"></div>
                        </div>
                    </div>

                    <!--==========Campos Interactivos (PADRES)==============-->

                    <div class="datos-body" *ngIf="item2.type == 'icon'"><!--Es para poner iconos-->
                        <img [src]="item2.function(rowdata)" alt="" style="height: 15px;">
                    </div>

                    <!-- TEXTOS PLANOS -->

                    <ng-content *ngIf="item2.type == 'text'" [ngStyle]="generateStyle(item2.style)">
                        <span class="text-xxs"> {{rowdata[item2.field]}}</span>
                    </ng-content>

                    <ng-content *ngIf="item2.type == 'date'">
                        <span class="text-xxs">{{ rowdata[item2.field] ? util.formatearfecha(rowdata[item2.field],
                            'dd/mm/yyyy') : ''}}</span>
                    </ng-content>

                    <ng-content *ngIf="item2.type == 'datetime'">
                        <span class="text-xxs">
                            {{rowdata[item2.field] ? util.formatearfecha(rowdata[item2.field],'dd/mm/yyyy hh:mm'):''}}
                        </span>
                    </ng-content>

                    <!--  FIN TEXTOS PLANOS -->

                    <!-- CHECKBOX READONLY -->

                    <ng-content *ngIf="item2.type == 'checkbox'">
                        <p-checkbox [(ngModel)]="rowdata[item2.field]" [binary]="true" readonly="true" size="small" />
                    </ng-content>

                    <!-- CHECKBOX READONLY -->

                    <!-- CHECKBOX EDITABLE -->

                    <ng-content *ngIf="item2.type == 'checkboxEdit'">
                        <p-checkbox [(ngModel)]="rowdata[item2.field]" [binary]="true" size="small" inputId="binary"
                            (onChange)="item2.function({event:$event,row:rowdata})" />
                    </ng-content>

                    <!-- CHECKBOX READONLY -->

                    <!-- FECHA -->

                    <ng-content *ngIf="item2.type == 'dateEdit'">
                        <p-datepicker [(ngModel)]="rowdata[item2.field]" appendTo="body" [iconDisplay]="'input'"
                            [showIcon]="true" (ngModelChange)="handleDateSelect($event, rowdata)" dateFormat="dd/mm/yy"
                            styleClass="w-9rem max-w-9rem" />

                        <p-button [disabled]="selectedDate !== rowdata[this.key]" variant="outlined" severity="primary"
                            size="small" icon="pi pi-save" class="buttons_tabla" styleClass="h-2rem w-2rem"
                            (onClick)="item2.function({event:$event, row:rowdata}); isDisabled()" />
                    </ng-content>

                    <!-- FIN FECHA -->

                    <!-- LISTA -->

                    <ng-content *ngIf="item2.type == 'dropdownEdit'">
                        <p-select [options]="item2.list" [(ngModel)]="rowdata[item2.field]" appendTo="body"
                            optionLabel="nombre" optionValue="codigo" size="small" class="w-12rem max-w-12rem"
                            (onChange)="handleDropdownSelect($event)" [filter]="true" [showClear]="true"
                            styleClass="p-1rem" />
                        <p-button [disabled]="!selectDropdown" variant="outlined" severity="primary" size="small"
                            icon="pi pi-save" class="buttons_tabla" styleClass="h-2rem w-2rem"
                            (onClick)=" item2.function({event:$event,row:rowdata});isDisabled()" />
                    </ng-content>

                    <!--  FIN LISTA -->

                    <ng-content *ngIf="item2.type == 'button'">
                        <p-button variant="outlined" severity="primary" size="small" class="buttons_tabla"
                            styleClass="h-2rem w-2rem" icon={{item2.iconobutton}}
                            (onClick)="item2.function({event:$event,row:rowdata,index:expanded})"
                            pTooltip={{item2.toolTip}} [disabled]="item2.disabled" />
                    </ng-content>

                    <!-- <span *ngIf="item2.type == 'button'">
                        <p-button icon={{item2.iconobutton}} (onClick)="item2.function({event:$event,row:rowdata})"
                            pTooltip={{item2.toolTip}}>
                        </p-button>
                    </span> -->
                    <!-- <ng-content *ngIf="item2.type == 'checkboxEditForConfirmation'">
                        <p-checkbox [(ngModel)]="rowdata[item2.field]" [binary]="true" size="small" inputId="binary"
                            (onClick)="item2.function({event:$event,row:rowdata})" pTooltip="{{item2.toolTip}}" />
                    </ng-content> -->
                    <span
                        *ngIf="item2.type == 'checkboxEditForConfirmation'"><!--Boton q simula un checbox, usarlo para cuando quieres un checkbox q al presionar sale un p-confirm-->
                        <p-button [icon]="rowdata[item2.field]?'pi pi-check' :'pi pi-circle'"
                            (onClick)="item2.function({event:$event,row:rowdata})" pTooltip="{{item2.toolTip}}"
                            [styleClass]="rowdata[item2.field] ? 'h-2rem w-2rem' : 'p-button-help h-2rem w-2rem'"
                            class="buttons_tabla"></p-button>

                    </span>

                    <div class="row-button-table" *ngIf="item2.type == 'texticon'"
                        style="display: flex; justify-content: center;align-items: center;gap: 10px;">
                        <div style="width: 20px;text-align: right">{{rowdata[item2.field]}}</div>
                        <img [src]="item2.function(rowdata)" alt="" style="height: 15px;">
                    </div>


                    <span *ngIf="item2.type == 'buttonOneUse'"><!--Es un Boton que si recibe true de deshabilita-->
                        <p-button icon={{item2.iconobutton}} [disabled]="bool(rowdata[ item2.field])"
                            (onClick)="item2.function({event:$event,row:rowdata})" pTooltip={{item2.toolTip}}
                            [styleClass]="rowdata[item2.field] ? 'p-button-success' : ''">
                        </p-button>
                    </span>

                    <ng-content *ngIf="item2.type == 'textAreaEdit'">
                        <!-- <a (click)="showDialog(rowdata,item2.title,item2.field,'textAreaEdit',item2.function, rowdata[item2.field])"
                            class="text-xxs">
                            {{rowdata[item2.field] !== null && rowdata[item2.field] !== '' ? 'Ver detalle': 'Agregar detalle'}}
                        </a>
                        <link rel="stylesheet" href="" > -->
                        <span class="cursor-pointer underline"
                            (click)="showDialog(rowdata,item2.title,item2.field,'textAreaEdit',item2.function, rowdata[item2.field])"
                            class="text-xxs">
                            {{rowdata[item2.field] !== null && rowdata[item2.field] !== '' ? 'Ver detalle': 'Agregar
                            detalle'}}</span>
                    </ng-content>

                    <ng-content *ngIf="item2.type == 'textAreaEditBtn'">
                        <div style="display: flex; align-items: center; gap: 8px;">
                            <span *ngIf="rowdata[item2.field]"
                                style="max-width: 120px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: inline-block;font-size: 12px;">
                                {{ rowdata[item2.field] }}
                            </span>
                            <button pButton type="button"
                                [icon]="rowdata[item2.field] !== null && rowdata[item2.field] !== '' ? 'pi pi-eye' : 'pi pi-plus'"
                                class="p-button-rounded p-button-text p-button-info no-padding-btn"
                                (click)="showDialog(rowdata, item2.title, item2.field, 'textAreaEditBtn', item2.function, rowdata[item2.field])"
                                pTooltip="Ver Detalle" [tooltipPosition]="'left'">
                            </button>
                        </div>
                    </ng-content>


                    <span class="row-button-table"
                        *ngIf="item2.type == 'textArea'"><!--Es para un boton que abre un textArea-->
                        <p-button pRipple icon="pi pi-eye"
                            (click)="showDialog(rowdata,item2.title,item2.field,'textArea',item2.function, rowdata[item2.field])"
                            class="p-button-rounded p-button-text p-button-danger" pTooltip="Ver Detalle"
                            [tooltipPosition]="'left'"></p-button>
                    </span>

                </ng-container>
            </td>
        </tr>
        <p-contextMenu #expmenu [model]="contextMenu" [global]="false" appendTo="body"
            [target]="rowcontext"></p-contextMenu>
    </ng-template>

    <ng-template [pTemplate]="positionPaginator">
        <p-button type="button" icon="pi pi-plus" text />
    </ng-template>

</p-table>

<p-dialog header="GENERAL" [(visible)]="visibleP_Dialog_General"><!--[style]="{ width: '30vw' ; margin-top:'11rem'}"-->
    @if(visibleP_Dialog_General){
    <ng-template pTemplate="header">
        <span class="text-xl font-bold title-dialog">{{tituloP1_Dialog}}</span>
    </ng-template>
    <!--De anthony-->

    <!--Para TextArea-->
    <div *ngIf="visibleTextArea" class="flex py-2 justify-content-center"
        style="display: flex; justify-content: center;align-items: center; flex-direction: column-reverse; gap:10px">
        <div class="card flex justify-content-center">
            <textarea rows="5" cols="30" pInputTextarea [(ngModel)]="datoTextArea" style="resize: none;"></textarea>
        </div>
    </div>
    <!--Para TextAreaEdit-->
    <div *ngIf="visibleTextAreaEdit" class="flex py-2 justify-content-center"
        style="display: flex; justify-content: center;align-items: center; flex-direction: column-reverse; gap:10px">
        <div class="card flex justify-content-center">
            <textarea rows="5" cols="30" pInputTextarea [(ngModel)]="datoTextArea" style="resize: none;"></textarea>
        </div>
        <p-button icon="pi pi-check" (click)="onConfirm($event)"></p-button>
    </div>
    <!--Para textAreaEditBtn-->

    <div *ngIf="textAreaEditBtn" class="flex py-2 justify-content-center"
        style="display: flex; justify-content: center;align-items: center; flex-direction: column-reverse; gap:10px ">
        <div class="card flex justify-content-center">
            <textarea rows="10" cols="70" pInputTextarea [(ngModel)]="datoTextArea" style="resize: none;"></textarea>
        </div>
        <p-button icon="pi pi-check" (click)="onConfirmV2($event)"></p-button>
        <!-- <p-confirmPopup #confirmPopup ></p-confirmPopup> -->
    </div>
    }
</p-dialog>
<p-dialog header="Opciones" [(visible)]="optionColumns" [style]="{width: '50vw'}" appendTo="body">
    @if (optionColumns) {
    <p-pickList [source]="mainmetadata" [target]="metadatatable" [dragdrop]="true" [responsive]="true"
        [sourceStyle]="{ height: '20rem' }" [targetStyle]="{ height: '20rem' }" filterBy="title"
        sourceFilterPlaceholder="Buscar por nombre" targetFilterPlaceholder="Buscar por nombre" breakpoint="1400px"
        [filterMatchMode]="'contains'" filterLocale="title" (onMoveToSource)="limpiarFoco()"
        (onMoveToTarget)="limpiarFoco()" (onSourceReorder)="limpiarFoco()" (onTargetReorder)="limpiarFoco()"
        (onSourceSelect)="limpiarFoco()" (onTargetSelect)="limpiarFoco()">
        <ng-template #sourceHeader>
            <span style="font-size: 12px; font-weight: 600;">Disponibles</span>
        </ng-template>
        <ng-template #targetHeader>
            <span style="font-size: 12px; font-weight: 600;">Seleccionados</span>
        </ng-template>
        <ng-template let-option let-selected="selected" pTemplate="option">
            <div class="flex flex-wrap p-2 align-items-center gap-3">
                <div class="flex-1 flex flex-column gap-2">
                    <span style="font-size: 11px;font-weight: 500;text-transform: uppercase;" [ngClass]="{
                        'text-surface-500': !selected,
                        'dark:text-surface-400': !selected,
                        'text-inherit': selected,
                    }">{{ option.title }}</span>
                </div>
            </div>
        </ng-template>
    </p-pickList>
    <p-button icon="pi pi-save" [loading]="loadingBtnSave" (onClick)="saveOptionColumns()"
        pTooltip="Guardar"></p-button>
    }
</p-dialog>